export const martialStatusOptions = ["Married", "Single"] as const;

export type MaritalStatus = typeof martialStatusOptions[number];
